module.exports = __webpack_public_path__ + "img/logo-dark.1cc4b3c9.png";